
define('app/activation/actMain',[
	'domReady',
	'app/activation/actApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, ActApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		ActApp.initialize();
		UnknownSetup.initialize();
    });
});